// assets/product-custom-property-embroidery.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);

document.addEventListener("DOMContentLoaded", function() {
  const embroiderySelect = document.querySelector(`select[name*="刺繍"]`);
  const embroideryFields = document.querySelectorAll(".embroidery-property");
  if (!embroiderySelect || !embroideryFields.length) return;

  // 初期表示
  toggleEmbroideryFields(embroiderySelect.value);

  // select変更時
  embroiderySelect.addEventListener("change", function() {
    toggleEmbroideryFields(this.value);
  });

  function toggleEmbroideryFields(value) {
    embroideryFields.forEach(field => {
      if (value.includes("あり")) {
        field.style.display = "block";
      } else {
        field.style.display = "none";
        const inputs = field.querySelectorAll("input, textarea");
        inputs.forEach(input => {
          if (input.type === "radio") input.checked = false;
          else input.value = "";
        });
      }
    });
  }
});

